import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import TextButton from 'components/TextButton';
import {
  boletoAction,
  comprovanteDeEntregaAction,
  eventName,
  notaFiscalAction
} from 'components/ApplicationInsights/eventNames';
import { Visibility } from 'components/Visibility';

import iconDownload from 'img/arrow-download.svg';

import { OrdersTabsEnum } from 'models/Order';
import { DownloadInLotTypes } from '../interface';

interface OptionsDownloadInLotOrdersProps {
  handleSendRequestDownloadInLot: (orderAttachmentType: number) => void;
}

const OptionsDownloadInLotOrders: React.FC<OptionsDownloadInLotOrdersProps> = (props) => {

  const { handleSendRequestDownloadInLot } = props;

  const currentTabId = useSelector((state: RootState) => state.currentTab?.currentNameTab);

  const isInvoicedOrder = currentTabId === OrdersTabsEnum.PEDIDO_FATURADO;
  const isTriangleSale = currentTabId === OrdersTabsEnum.VENDA_TRIANGULAR;

  return (
    <>
      <TextButton
        title="Boleto"
        onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.BILLET)}
        loading={false}
        trackName={eventName.BOLETO}
        trackAction={boletoAction.DOWNLOAD_LOTE_BOLETO}
        img={iconDownload}
        className="ml-2 mr-3"
      />

      <Visibility visible={isInvoicedOrder}>
        <TextButton
          title="NFe"
          onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.INVOICE)}
          loading={false}
          trackName={eventName.NOTA_FISCAL}
          trackAction={notaFiscalAction.DOWNLOAD_LOTE_PDF}
          img={iconDownload}
          className="mr-3" />
        <TextButton
          title="XML"
          onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.INVOICE_XML)}
          loading={false}
          trackName={eventName.NOTA_FISCAL}
          trackAction={notaFiscalAction.DOWNLOAD_LOTE_XML}
          img={iconDownload}
          className="mr-3" />
        <TextButton
          title="Canhoto"
          onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.RECEIPT)}
          loading={false}
          trackName={eventName.COMPROVANTE_DE_ENTREGA}
          trackAction={comprovanteDeEntregaAction.PEDIDO_COMPROVANTEENTREGA}
          img={iconDownload}
          className="mr-3" />
      </Visibility>

      <Visibility visible={isTriangleSale}>
        <TextButton
          title="NFe"
          onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.INVOICE_SHIPPING)}
          loading={false}
          trackName={eventName.NOTA_FISCAL_REMESSA}
          trackAction={notaFiscalAction.DOWNLOAD_LOTE_PDF}
          img={iconDownload}
          className="mr-3" />
        <TextButton
          title="XML"
          onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.INVOICE_SHIPPING_XML)}
          loading={false}
          trackName={eventName.NOTA_FISCAL_REMESSA}
          trackAction={notaFiscalAction.DOWNLOAD_LOTE_XML}
          img={iconDownload}
          className="mr-3" />
        <TextButton
          title="Canhoto"
          onSendRequest={() => handleSendRequestDownloadInLot(DownloadInLotTypes.RECEIPT_SHIPPING)}
          loading={false}
          trackName={eventName.COMPROVANTE_DE_ENTREGA_REMESSA}
          trackAction={comprovanteDeEntregaAction.DOWNLOAD_LOTE_COMPROVANTEENTREGA_REMESSA}
          img={iconDownload}
          className="mr-3" />
      </Visibility>


    </>
  );
};

export default OptionsDownloadInLotOrders;